import { ErrorResponse } from './../../../models/error.model';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from './../../../services/utils.service';
import { BrokersService } from './../../../services/brokers.service';
import { Broker } from './../../../models/broker.model';
import { Component, OnInit } from '@angular/core';
import { ID } from '../../../models/ID.model';

@Component({
  selector: 'app-broker-details',
  templateUrl: './broker-details.component.html',
  styleUrls: ['./broker-details.component.scss']
})
export class BrokerDetailsComponent implements OnInit {

    broker?: Broker;

    constructor(
        private brokersService: BrokersService,
        private utilsService: UtilsService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id) {
                this.getBroker(params.id);
            }
        });
    }

    getBroker(id: ID) {
        this.brokersService.getBrokerById(id).subscribe(broker => {
            this.broker = broker;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener detalles del agente', error.error?.descripcion));
    }
}
